function FinancialCoaching() {
  return (
    <div class="w-full bg-white px-5 py-16 md:py-16 text-gray-800">
      <style>
        @import
        url('https://cdnjs.cloudflare.com/ajax/libs/MaterialDesign-Webfont/5.3.45/css/materialdesignicons.min.css')
      </style>
      <div class="w-full mt-10 max-w-6xl mx-auto">
        <div class="text-center mx-auto">
          <h1 class="text-4xl md:text-6xl font-bold mb-3 text-gray-900">
            Financial Coaching
          </h1>
          <h2 class="text-xl md:text-3xl font-bold mb-3 text-gray-600">
            Personalized Guidance for Real-Life Goals
          </h2>
          <div class="text-center mb-4">
            <span class="inline-block w-1 h-1 rounded-full bg-green-500 ml-1"></span>
            <span class="inline-block w-3 h-1 rounded-full bg-green-500 ml-1"></span>
            <span class="inline-block w-40 h-1 rounded-full bg-green-500 ml-1"></span>
            <span class="inline-block w-3 h-1 rounded-full bg-green-500 ml-1"></span>
            <span class="inline-block w-1 h-1 rounded-full bg-green-500 ml-1"></span>
          </div>
        </div>
        <div class="flex flex-col gap-y-5 justify-center">
          <p className="text-left leading-6 text-lg">
            Everyone's financial journey is unique. Whether you're just getting
            started or looking to make smarter decisions with your money,
            personalized coaching can provide clarity, confidence, and a
            practical plan. My approach is grounded in the principles from The
            Financial Compass—clear, approachable, and action-focused.
          </p>
          <h2 className="text-left font-bold leading-7 text-gray-900 text-xl">
            What I Offer
          </h2>
          <h2 className="text-left font-semibold leading-7 text-gray-900 text-xl">
            1. One-on-One Coaching
          </h2>
          <ul className="ml-8 text-left list-disc list-inside text-lg">
            <li>
              Personalized sessions tailored to your financial questions,
              challenges, or goals
            </li>
            <li>
              Ideal for young adults, recent grads, or those feeling overwhelmed
              by financial choices
            </li>
            <li>Sessions can be virtual or in-person (if applicable)</li>
          </ul>
          <h2 className="text-left font-semibold text-gray-900 text-xl">
            2. Group Coaching / Workshops
          </h2>
          <h2 className="text-left font-bold text-gray-900 text-xl">
            My Coaching Style
          </h2>
          <p className="text-left leading-6 text-lg">
            Supportive, no judgment, and completely focused on helping you feel
            empowered—not overwhelmed. My goal is not to sell financial
            products, but to build financial understanding and confidence.
          </p>
          <h2 className="text-left font-bold leading-7 text-gray-900 text-xl">
            How it Works
          </h2>
          <ol className="ml-8 text-left list-disc list-inside text-lg">
            <li>
              <b>Free 15-minute discovery call</b> – Let’s talk about what
              you’re hoping to achieve.
            </li>
            <li>
              <b>Custom coaching plan</b> – Tailored to your needs, schedule,
              and comfort level.
            </li>
            <li>
              <b>Follow-up support</b> – Optional sessions to help you stay on
              track.
            </li>
          </ol>
          <p className=" text-left leading-6 text-lg">
            Let’s take the first step together. Schedule a free, no-obligation
            discovery call today.
          </p>
          <a
            href="/contact#Form"
            className="mx-5 oswald bg-green-500 mt-14 text-white font-bold py-2 px-5 rounded text-2xl max-w-xs text-center hover:bg-green-600 transition-colors duration-300"
            style={{ scrollBehavior: "smooth" }}
          >
            Contact Form
          </a>
        </div>
      </div>
    </div>
  );
}

export default FinancialCoaching;
